<template>
    <section class="register textSection">
        <h1>Inscription</h1>
        <div v-show="!getUser">

         <p>Inscrivez-vous à la formation <br><em>Savoir Être Aidant</em> pour suivre le MOOC.</p>

            <form v-on:submit.prevent="onSubmit">
                <label>Nom *</label>
                <input type="text" v-model="registerNom" required="required" placeholder="Nom" />

                <label>Prenom *</label>
                <input type="text" v-model="registerPrenom" required="required" placeholder="Prenom" />

                <label for="civilite">Civilité *</label>
                <select v-model="registerCivilite" id="civilite">
                    <option value="m">Homme</option>
                    <option value="f">Femme</option>
                </select>

                <label>Adresse email *</label>
                <input type="text" v-model="registerEmail" required="required" placeholder="name@example.com" />
                <span v-if="invalidEmail">Email invalide</span>
                <span v-if="emailAlreadyTaken">Email déjà utilisé</span>

                <label>Mot de passe *</label>
                <input type="password" v-model="registerPassword" required="required" placeholder="******" />
                <span v-if="invalidPassword">
                    Le mot de passe doit :<br>
                    <ul>
                        <li>contenir plus de 6 caractères</li>
                    </ul>
                </span>
                
                <label>Confirmer mot de passe *</label>
                <input type="password" v-model="registerConfirmation" required="required" placeholder="******" />
                <span v-if="invalidConfirmation">La confirmation ne correspond pas au mot de passe</span>
              <button type="submit">S'inscrire</button> 


                <span v-if="registerMessage">{{ registerMessage }}</span>
            </form>
            <!-- <form action="/todo">
                <button type="submit" disabled="disabled">Inscription avec Google</button>
            </form> -->
        </div>

        <div v-show="!getUser">
            <h2>Pourquoi s’inscrire sur <em>Savoir Être Aidant</em> ?</h2>
            
            <p><em>Savoir Être Aidant</em> est une formation en ligne, gratuite et ouverte à tous qui vous permettra d'aborder avec plus de sérénité votre rôle d'aidant. Conçue avec des experts du vieillissement et de l'aide, <em>Savoir Être Aidant</em> vous propose une formation s'adaptant à vous : </p>
            <ul>
                <li><strong>Niveau 1 :</strong> <em>Savoir Être Aidant</em>, c'est avant tout un libre accès à l'ensemble des
                    vidéos traitant des multiples enjeux du vieillissement et de la place des aidants pour chacun d'entre
                    eux.</li>
                <li><strong>Niveau 2 :</strong> En vous inscrivant sur le site <em>Savoir Être Aidant</em>, vous disposerez de
                    contenus supplémentaires (fiches pratiques, conseils, sites partenaires...) qui vous offriront la possibilité
                    de vous renseigner plus largement sur chacun de ces enjeux. </li>
                <li><strong>Niveau 3 :</strong> Une fois inscrit, vous pourrez alors démarrer la formation qui en plus des vidéos
                    et des contenus supplémentaires, vous offrira la possibilité de tester votre compréhension des besoins
                    de votre proche et de votre rôle. A l’issue de la formation, vous pourrez alors obtenir une certification.</li>
            </ul>
        </div>
    </section>
</template>

<script>
    import UsersService from '../services/users.js'
    import AuthenticationService from '../services/authentication.js'
    import {mapGetters} from 'vuex'

    const emailRegex = new RegExp('^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$')

    export default {
        name: 'register',
        data: function () {
            return {
                user: null,
                token: null,
                registerNom: null,
                registerPrenom: null,
                registerEmail: null,
                registerCivilite: null,
                registerPassword: null,
                registerConfirmation: null,
                invalidEmail: false,
                invalidPassword: false,
                invalidConfirmation: false,
                emailAlreadyTaken: false,
                registerMessage: null,
            }
        },
        created: function () {
            if(localStorage.getItem("access_token")) {
                this.$router.replace('/')
            }
        },
        methods: {
            onQuit: function () {
                this.$router.replace('/');
            },
            onSubmit: function () {
                this.invalidEmail = false
                this.invalidPassword = false
                this.invalidConfirmation = false
                this.emailAlreadyTaken = false
                this.registerMessage = null

                let anyError = false

                if (!emailRegex.test(this.registerEmail)) {
                    this.invalidEmail = true
                    anyError = true
                }

                if (!this.registerPassword || this.registerPassword.length < 6) {
                    this.invalidPassword = true
                    anyError = true
                } else if (!this.registerPassword || !this.registerConfirmation || this.registerPassword !== this.registerConfirmation) {
                    this.invalidConfirmation = true
                    anyError = true
                }

                if (!anyError) {
                    UsersService.create({
                        prenom: this.registerPrenom,
                        nom: this.registerNom,
                        email: this.registerEmail,
                        civilite: this.registerCivilite,
                        passwordHash: this.registerPassword,
                    }).then((res) => {
                        this.registerNom = null;
                        this.registerPrenom = null;
                        this.registerEmail = null;
                        this.registerCivilite = null;
                        this.registerPassword = null;
                        this.registerConfirmation = null;
                        this.registerMessage = `Un mail de confirmation a été envoyé sur votre boite mail, s'il n'apparait pas veuillez vérifier vos spam`
                        // this.$router.replace('/');
                    }, (res) => {
                        if (res.status === 400) {
                            this.emailAlreadyTaken = true
                        } else {
                            this.registerMessage = `Une erreur s'est produite lors de l'inscription.`
                        }
                    })
                }
            },
            setLoggedUser: function () {
                AuthenticationService.getUserByToken({
                    token: this.token
                }).then((res) => {
                    this.user = res.body[0];
                }, (res) => {
                    console.log(res);
                });
                return this.user
            },
        },
        computed: {
            ...mapGetters(['getUser'])
        }
    }
</script>

<style>
    .register {
        min-height: 500px;
    }
    #indisponible h3{
        position: absolute;
        text-align: center;
    }
     #construction img {
        position: absolute;
        margin-left : -120px;
        margin-top: 10px;
    }
    #construction2 img {
        position: absolute;
        margin-left : 430px;
        margin-top: 10px;
    }
    .register div:first-of-type {
        max-width: 50%;
        float: left;
        margin-left: 10%;
    }

    .register div:last-of-type {
        max-width: 50%;
        margin-left: 50%;
        margin-top: -90px;
    }

    .register form {
        width: 60%;
        border-left: solid 1px #662483;
        padding-left: 5px;
        color: #662483;
        text-align: left;
        display: flex;
        flex-direction: column;
        margin-left: 5%;
    }

    .register input {
        width: 200px;
        border: 1px solid grey;
        padding: 3px;
        margin-left: 3px;
        color: #009fe3;
        background-color: none;
    }

    .register select {
        width: 208px;
        border: 1px solid grey;
        padding: 2px;
        margin-left: 3px;
    }

    .register label {
        margin: 5px;
    }

    .register button {
        max-width : 50%;
        border: black solid 1px;
        padding: 3px;
        background-color: white;
        margin: 3px;
    }

    .register button:hover {
        border: black solid 1px;
        padding: 8px;
        background-color: lightgrey;
        cursor: pointer;
    }

    .register span {
        border: solid 1px #662483;
        padding: 2px;
        margin: 3px;
        color: #009fe3;
    }

    #redirectInModal {
        color: black;
        font-weight: bolder;
        text-align: center;
        padding-top: 50px;
        margin-left: 30%;
    }

    #modalModif {
        padding: 10px;
        margin-bottom: 20px;
    }
    
</style>



// WEBPACK FOOTER //
// Register.vue?26215f0f